import { ExperimentVariants } from '@gumtree/shared/src/types/client-data';
import { getGrowthbookClientSide } from '@gumtree/shell/src/growthbook/init-growthbook';

type FeatureValueFormat = (value: boolean | string | undefined) => ExperimentVariants | '' | 'OFF';

// GrowthBookAdFeatures key exprimentId, value is feature. for exprimentId !== featureKey
export const GrowthBookAdFeatures = {
    'bid01': 'bid01',
    'pre-ad-source': 'pre-ad-source',
    'bid02': 'bid02',
    'prebid-timeout': 'prebid-timeout',
    'adsence-admarketplace': 'adsence-admarketplace',
    'nearby-listing-new-ads': 'nearby-listing-new-ads',
    'consent-banner-new-design': 'consent-banner-new-design',
    'adsense-query': 'adsense-query',
};

export const featuresToKeyValue = (
    features: Record<string, string>,
    format: FeatureValueFormat = (val) => val as ExperimentVariants
) => {
    const growthbookClient = getGrowthbookClientSide();
    if (!growthbookClient) return [];
    return Object.entries(features)
        .map(([exprimentId, feature]) => {
            const value = format(growthbookClient.getFeatureValue(feature, ''));
            if (value === '' || value === 'OFF') return null;
            return [exprimentId, value];
        })
        .filter(Boolean) as string[][];
};
